import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, resolveDirective as _resolveDirective, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createTextVNode as _createTextVNode, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex justify-end gap-2 font-semibold" }

import Button from 'primevue/button';
import Dialog from 'primevue/dialog';

import { ref } from 'vue';

import { useDataSync } from '../composables/useDataSync';


export default /*@__PURE__*/_defineComponent({
  __name: 'DataSyncDialog',
  setup(__props) {

const { isLoading, syncData } = useDataSync();

const isModalShow = ref(false);

return (_ctx: any,_cache: any) => {
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives((_openBlock(), _createBlock(_unref(Button), {
      class: "!bg-transparent hover:!bg-slate-800",
      severity: "secondary",
      text: "",
      icon: "",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (isModalShow.value = true))
    }, {
      default: _withCtx(() => _cache[4] || (_cache[4] = [
        _createElementVNode("i", { class: "pi pi-sync !text-xl text-white" }, null, -1)
      ])),
      _: 1
    })), [
      [
        _directive_tooltip,
        'Aktualizuj dane',
        void 0,
        { bottom: true }
      ]
    ]),
    _createVNode(_unref(Dialog), {
      visible: isModalShow.value,
      "onUpdate:visible": _cache[3] || (_cache[3] = ($event: any) => ((isModalShow).value = $event)),
      modal: "",
      header: "Czy na pewno chcesz zsynchronizować dane?",
      style: { width: '50%', 'max-width': '40rem' }
    }, {
      default: _withCtx(() => [
        _cache[7] || (_cache[7] = _createElementVNode("p", { class: "mb-4" }, " Wszystkie lokalne dane zostaną usunięte i zastąpione najnowszymi danymi z serwera. Utracisz niezapisane zmiany. ", -1)),
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_unref(Button), {
            size: "small",
            severity: "secondary",
            outlined: "",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (isModalShow.value = false))
          }, {
            default: _withCtx(() => _cache[5] || (_cache[5] = [
              _createTextVNode(" Anuluj ")
            ])),
            _: 1
          }),
          _createVNode(_unref(Button), {
            size: "small",
            loading: _unref(isLoading),
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(syncData)()))
          }, {
            default: _withCtx(() => _cache[6] || (_cache[6] = [
              _createTextVNode(" Aktualizuj ")
            ])),
            _: 1
          }, 8, ["loading"])
        ])
      ]),
      _: 1
    }, 8, ["visible"])
  ], 64))
}
}

})